import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { pick } from '../../core/common/helpers/objects/object.helper';
import { Resolvable } from '../../core/common/services/resolvable.abstract.service';

export abstract class ConfigService<T> extends Resolvable<T> {
    protected config$: Observable<T>;
    // Default to empty object so to prevent accessing its key caused ReferenceError ("not defined", instead of "undefined")
    protected saved: T = {} as T;

    protected initConfigListener() {
        this.getConfig()
            .pipe(take(1))
            .subscribe(config => {
                this.saved = config;
            });
    }

    public abstract initialize(): Observable<T>;

    public get<K extends keyof T>(key: K): Observable<NonNullable<any>> {
        return this.getConfig().pipe(map(config => config[key]));
    }

    public getInstant<K extends keyof T>(key: K): NonNullable<T[K]> | undefined {
        return this.saved[key] ?? undefined;
    }

    public getAllInstant<K extends keyof T>(...keys: K[]): Pick<T, K> | undefined {
        if (!this.saved) {
            return undefined;
        }
        return pick(this.saved, ...keys);
    }

    public getConfig(): Observable<T> {
        return this.config$ ? this.config$ : this.initialize();
    }
}
